import { Button } from "../../../../../../common/APICommon";
import { Input, NumberInput } from "../../../../../../common/Input";

import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';

export function CategoryForm({
  editingCategory,
  newCategory,
  categoryErrors,
  onFieldChange,
  onAddCategory,
  onUpdateCategory,
  onCancelEdit
}) {
  return (
    <div className="mb-8 rounded-lg border border-gray-200 bg-white p-6 shadow-sm">
      <div className="mb-4">
        <h3 className="text-lg font-semibold text-gray-800">
          {editingCategory ? "Edit Performance Category" : "Add Performance Category"}
        </h3>
        <p className="text-sm text-gray-600 mt-1">
          {editingCategory ? "Update the category details" : "Create a new performance category"}
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div>
          <Input
            label="Description:"
            isRequired={true}
            type="text"
            value={editingCategory ? editingCategory.description : newCategory.description}
            onChange={(e) => onFieldChange("description", e.target.value)}
            placeholder="e.g., Business Objectives, Leadership Skills"
            error={categoryErrors.description}
            errorMessage="Description is required"
          />
        </div>
        <div>
          <NumberInput
            label="Total Percentage:"
            isRequired={true}
            value={editingCategory ? editingCategory.totalPercentage : newCategory.totalPercentage}
            onChange={(e) => onFieldChange("totalPercentage", e.target.value)}
            placeholder="e.g., 75"
            min="0"
            max="100"
            step="0.01"
            error={categoryErrors.totalPercentage}
            errorMessage="Valid percentage is required (0-100)"
          />
        </div>
        <div className="flex items-end space-x-3">
          <Button
            icon={<AddIcon />}
            name={editingCategory ? "Update Category" : "Add Category"}
            className={"bg-blue-500 hover:bg-blue-600 border-none cursor-pointer"}
            onClick={editingCategory ? onUpdateCategory : onAddCategory}
          />
          {editingCategory && (
            <Button
              icon={<CloseIcon />}
              name={"Cancel"}
              className={"bg-gray-400 hover:bg-gray-400 text-gray-800 border-none cursor-pointer"}
              onClick={onCancelEdit}
            />
          )}
        </div>
      </div>
    </div>
  );
}